class TrShowMoreText extends HTMLElement {
  selectors = {
    content: '[data-tr-js-show-more-text-content]',
    button: '[data-tr-js-show-more-text-button]'
  };

  attributes = {};

  stateClasses = {
    isExpanded: 'is-expanded'
  };

  connectedCallback() {
    this.contentElement = this.querySelector(this.selectors.content);
    this.buttonElement = this.querySelector(this.selectors.button);

    // Initial calculation ko next frame par schedule karein taake page parsing block na ho
    requestAnimationFrame(() => {
      this.init();
      this.bindEvents();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onWindowResize);
    this.destroy();
  }

  init() {
    this.isExpanded = this.classList.contains(this.stateClasses.isExpanded);
    this.update();
  }

  bindEvents() {
    if (!this.buttonElement) return;

    this.buttonElement.addEventListener('click', this.onButtonClick);
    window.addEventListener('resize', this.onWindowResize);
  }

  onButtonClick = () => {
    this.isExpanded = !this.isExpanded;
    this.classList.toggle(this.stateClasses.isExpanded, this.isExpanded);
    this.update();
  };

  // Resize par debounce taake CPU choke na ho
  onWindowResize = () => {
    if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
    this._resizeRaf = requestAnimationFrame(() => {
      this.update();
    });
  };

  update() {
    if (!this.contentElement || !this.buttonElement) return;

    if (this.isExpanded) {
      this.clearCollapsedContentStyles();
      this.buttonElement.hidden = !this.hasOverflow;
      this.buttonElement.style.visibility = '';
      this.updateButton();
      return;
    }

    // Step 1: Read phase ko batch karein
    requestAnimationFrame(() => {
      this.clearCollapsedContentStyles();

      const lineHeight = this.getContentLineHeight();
      const visibleHeight = this.getContentVisibleHeight();
      const visibleLines = Math.max(1, Math.floor(visibleHeight / lineHeight));
      const collapsedHeight = visibleLines * lineHeight;
      const hasOverflow = this.contentElement.scrollHeight > collapsedHeight + 1;
      this.hasOverflow = hasOverflow;

      // Step 2: Write phase
      if (hasOverflow) {
        this.applyCollapsedContentStyles(visibleLines);
      }

      this.buttonElement.hidden = !hasOverflow;
      this.buttonElement.style.visibility = '';
      this.updateButton();
    });
  }

  updateButton() {
    const collapsedText =
      this.buttonElement.getAttribute('data-collapsed-text') ||
      this.buttonElement.textContent;
    const expandedText =
      this.buttonElement.getAttribute('data-expanded-text') || collapsedText;

    this.buttonElement.textContent = this.isExpanded
      ? expandedText
      : collapsedText;
    this.buttonElement.setAttribute('aria-expanded', String(this.isExpanded));
  }

  applyCollapsedContentStyles(visibleLines) {
    this.contentElement.style.display = '-webkit-box';
    this.contentElement.style.webkitBoxOrient = 'vertical';
    this.contentElement.style.webkitLineClamp = String(visibleLines);
    this.contentElement.style.overflow = 'hidden';
  }

  clearCollapsedContentStyles() {
    this.contentElement.style.display = '';
    this.contentElement.style.webkitBoxOrient = '';
    this.contentElement.style.webkitLineClamp = '';
    this.contentElement.style.overflow = '';
  }

  getContentLineHeight() {
    const contentStyles = window.getComputedStyle(this.contentElement);
    const parsedLineHeight = parseFloat(contentStyles.lineHeight);

    if (Number.isFinite(parsedLineHeight)) {
      return parsedLineHeight;
    }

    const parsedFontSize = parseFloat(contentStyles.fontSize);
    return Number.isFinite(parsedFontSize) ? parsedFontSize * 1.2 : 16;
  }

  getContentVisibleHeight() {
    const wrapperElement = this.contentElement.parentElement;
    return wrapperElement
      ? wrapperElement.clientHeight
      : this.contentElement.clientHeight;
  }

  destroy() {
    if (!this.buttonElement) return;
    this.buttonElement.removeEventListener('click', this.onButtonClick);
    if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
  }
}

if (!customElements.get('tr-show-more-text')) {
  customElements.define('tr-show-more-text', TrShowMoreText);
}